import {Injectable,} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {FatherService} from './father.service';
import {LocalstorageService} from './localstorage.service';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {find} from 'lodash-es';
import {SidenavService} from "./sidenav.service";
import {SnakeService} from "./snake.service";
import {AppConfig} from "../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends FatherService {

  updateSettingsUsers = new Subject();
  public updateList$: Subject<boolean> = new Subject();

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService,
    public dialog: MatDialog,
    public router: Router,
    public sidenavService: SidenavService,
    public snakeService: SnakeService,
  ) {
    super(httpClient, localstorageService);
  }


  getUserList(ipAddress:string, token: string): Observable<any> {
    return this.post(`${ipAddress}/api/get-user-list`, {token: token});
  }

  setAutocompleteValue(fieldName: string, arr: any, model: any): any {
    const field = find(arr, (item) => item.id === model[fieldName]);
    if (field) {
      model[fieldName] = {label: field.name, value: field.id};
    }
    return model;
  }

  errorHandler(res: any): void {
    if (res && !res.error) {
      this.sidenavService.sideNavState$.next(false);
      this.updateSettingsUsers.next(true);
    } else {
      this.snakeService.showSnake($localize`:@@ERROR:ERROR`);
    }
  }


  createUser(data: any, ipAddress: string, token: string): Observable<any> {
    return this.post(`${ipAddress}/api/create-user`, {token, data});
  }


}
